import { getNumberFormat } from "../../utils/enums";

export const TarifeeColumns = () => {
  return [
    { field: "id", headerName: "ID", width: 90, hide: true },
    {
      field: "commissionPackName",
      headerName: "Tarife Adı",
      sortable: false,
      flex:1,
      align: "left",
      headerAlign: "center",
      valueGetter: (params) => {
        return params.value  //getGuarantorDesc(params.value);
      },
    },
    {
      field: "commissionPackPrice",
      headerName: "Tutar",
      sortable: false,
      width:200,
      align: "right",
      headerAlign: "center",
      valueGetter: (params) => {
        return getNumberFormat(params.value);
      },
    },
  ];
};